import React, { useEffect, useState } from "react";
import {
  CircularProgress,
  Grid,
  Card,
  CardContent,
  Typography,
  FormControl,
  InputLabel,
  NativeSelect,
  FormHelperText,
} from "@material-ui/core";
import { Instalacao, StatusPista } from "../models/posto";
import { getCombustivelDefByNome } from "../models/combustivel";
import { AvatarCombustivel } from "../components/avatarCombustivel";
import numeral from "numeral";
import { LocalGasStation } from "@material-ui/icons";
import { useFetcher } from "../components/api";

const REFRESH_INTERVAL_MS = 5000;

export const StatusBicosPage = () => {
  const [instalacoes, setInstalacoes] = useState<Instalacao[]>([]);
  const [instalacaoSelecionada, setInstalacaoSelecionada] =
    useState<Instalacao>();

  // O Cloud le o srvaba pela tunnel a cada chamada, entao a tela busca sozinha
  // em vez de esperar um push.
  const { response, error } = useFetcher<StatusPista>(
    "statusPistas",
    REFRESH_INTERVAL_MS,
  );

  const status = response?.data?.data ?? {};
  const carregando = response === undefined && error === undefined;

  // on status change
  useEffect(() => {
    const installs = Object.keys(status).map(
      (x) =>
        ({
          installCode: status[x].ic,
          empresa: {
            codigo: status[x].cod,
            nome: status[x].nome,
          },
        }) as Instalacao,
    );
    setInstalacoes(installs);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [response]);

  useEffect(() => {
    if (instalacoes?.length > 0 && instalacaoSelecionada === undefined)
      setInstalacaoSelecionada(instalacoes[0]);
  }, [instalacoes, instalacaoSelecionada]);

  const handleEmpresaSelectChange = (event: any) => {
    const newValue = instalacoes.find(
      (x) => x.installCode === event.target.value,
    );
    setInstalacaoSelecionada(newValue);
  };

  const statusAutomacao =
    status && instalacaoSelecionada
      ? status[instalacaoSelecionada.installCode]
      : undefined;
  const statusBicos = statusAutomacao?.status ?? [];
  const statusDefs = [
    { status: 0, nome: "Parada", color: "#338DD8" },
    { status: 1, nome: "Abastecendo", color: "#1CA757" },
    { status: 2, nome: "Offline", color: "#A8B2BA" },
    { status: 3, nome: "Solicitando Liberação", color: "#f3b133" },
    { status: 4, nome: "Bloqueado", color: "#f76c0b" },
    { status: 5, nome: "Erro", color: "#d73009" },
  ];

  return (
    <div>
      {carregando ? (
        <CircularProgress />
      ) : (
        <div>
          <div style={{ fontSize: "10px", width: "100%", textAlign: "center" }}>
            <p>Atualizado em: {statusAutomacao?.atualizadoEm}</p>
          </div>

          {instalacoes.length > 1 ? (
            <FormControl style={{ width: "100%" }}>
              <InputLabel htmlFor="select-instalacoes">Empresas</InputLabel>
              <NativeSelect
                fullWidth={true}
                value={instalacaoSelecionada}
                onChange={handleEmpresaSelectChange}
                inputProps={{
                  id: "select-instalacoes",
                }}
              >
                {instalacoes.map((item, idx) => (
                  <option key={idx} value={item.installCode}>
                    {item.installCode}: {item.empresa.codigo} -{" "}
                    {item.empresa.nome}
                  </option>
                ))}
              </NativeSelect>
              <FormHelperText>Escolha a empresa</FormHelperText>
            </FormControl>
          ) : (
            <></>
          )}

          {statusAutomacao?.error && (
            <div style={{ textAlign: "center", padding: "24px 0" }}>
              <p>Posto indisponível no momento.</p>
              <p style={{ fontSize: "12px" }}>{statusAutomacao.error}</p>
            </div>
          )}

          <Grid container spacing={2} style={{ paddingBottom: "16px" }}>
            {statusBicos?.map((x: any) => {
              const sigla = getCombustivelDefByNome(x.combustivelNome).sigla;
              const statusDef = statusDefs.find((st) => st.status === x.status);
              return (
                <Grid key={x.id} item xl={2} lg={2} md={3} sm={4} xs={6}>
                  <Card variant="outlined">
                    <CardContent>
                      <Grid
                        container
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                      >
                        <Typography
                          variant="h6"
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <LocalGasStation style={{ paddingRight: "4px" }} />
                          {x.id}
                        </Typography>
                        <AvatarCombustivel
                          combustivelSigla={sigla}
                          size="small"
                        />
                      </Grid>

                      <Typography
                        variant="overline"
                        display="block"
                        align="right"
                        style={{ marginTop: "6px" }}
                      >
                        {numeral(x.encerrante).format(",0.00")} (L)
                      </Typography>
                      <Typography
                        variant="overline"
                        display="block"
                        align="right"
                      >
                        R$ {numeral(x.preco).format(",0.000")}
                      </Typography>
                    </CardContent>
                    <div
                      style={{
                        textAlign: "center",
                        padding: "4px",
                        backgroundColor: statusDef?.color,
                      }}
                    >
                      {statusDef?.nome}
                    </div>
                  </Card>
                </Grid>
              );
            })}
          </Grid>
        </div>
      )}
    </div>
  );
};
